import { useGetRescheduleOptions } from "hooks/api/appointments/useGetRescheduleOptions";
import React, { createContext, useState } from "react";
import { useParams } from "react-router-dom";
import { STEPS } from "./utils";

const ReschedulingContext = createContext();

export const ReschedulingProvider = ({ children }) => {
  const { id: appointmentId } = useParams();
  const [currentStep, setCurrentStep] = useState(STEPS.makeupDay);
  const [reschedulingHistory, setReschedulingHistory] = useState([]);
  const [newAppointmentTime, setNewAppointmentTime] = useState(null);
  const { rescheduleOptions, rescheduleOptionsLoading, error, isError } =
    useGetRescheduleOptions(appointmentId);
  const {
    callInfo,
    clinicianAvailableAppointmentTimes,
    intersectionAvailability,
    clientMakeupDays,
  } = rescheduleOptions || {};

  React.useEffect(() => {
    if (rescheduleOptionsLoading) return;
    // Set the initial step based on the reschedule options
    if (clientMakeupDays?.length > 0) setStep(STEPS.makeupDay);
    else setStep(STEPS.recommendations);
  }, [rescheduleOptionsLoading]);

  const setStep = (step) => {
    setCurrentStep(step);
    setReschedulingHistory([...reschedulingHistory, step]);
  };

  const onBack = () => {
    const previousStep = reschedulingHistory[reschedulingHistory.length - 2];
    setStep(previousStep);
    setReschedulingHistory(reschedulingHistory.slice(0, -1));
  };

  return (
    <ReschedulingContext.Provider
      value={{
        currentStep,
        setStep,
        onBack,
        rescheduleOptionsLoading,
        callInfo,
        clinicianAvailableAppointmentTimes,
        intersectionAvailability,
        reschedulingHistory,
        newAppointmentTime,
        setNewAppointmentTime,
        reschedulingError: error,
        isReschedulingError: isError,
        clientMakeupDays,
      }}
    >
      {children}
    </ReschedulingContext.Provider>
  );
};

export const useRescheduling = () => {
  const context = React.useContext(ReschedulingContext);
  if (!context) {
    throw new Error("useRescheduling must be used within a ReschedulingProvider");
  }
  return context;
};
